<div class="col-2-parent structure-container">
    <div class="structure-col" [class.selected]="selectedSIindex===sIndex && selectedCIndex===0"
        (click)="twoColumnClicked(0)">
        <ng-container *ngFor="let b of structure.blocks[0];let i=index; let f = first;let l = last">
            <app-block [block]="b" [sIndex]="sIndex" [cIndex]="0" [bIndex]="i" [firstIndex]="f"
                [lastIndex]="l"></app-block>
        </ng-container>
    </div>
    <div class="structure-col" [class.selected]="selectedSIindex===sIndex && selectedCIndex===1"
        (click)="twoColumnClicked(1)">
        <ng-container *ngFor="let b of structure.blocks[1];let i=index; let f = first;let l = last">
            <app-block [block]="b" [sIndex]="sIndex" [cIndex]="1" [bIndex]="i" [firstIndex]="f"
                [lastIndex]="l"></app-block>
        </ng-container>
    </div>
</div>